import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'birdhouseWood', d: 'M-1.5,-2.5h1v0.5h-1zM-1,-2h1v0.5h-1zM-0.5,-1.5h0.5v2.5h-0.5z' },
    {
      paint: 'cherryTrunk',
      d: 'M1,-5h0.5v0.5h-0.5zM1,-4.5h1v0.5h-1zM-2,-4h0.5v0.5h-0.5zM0.5,-4h0.5v0.5h-0.5zM-0.5,-3.5h1v0.5h-1z',
    },
    {
      paint: [
        ['birdhouseWood', 0.72],
        ['shadow', 0.28],
      ],
      d: 'M0,-5.5h0.5v0.5h-0.5zM-1.5,-4h0.5v1.5h-0.5zM0,-4h0.5v0.5h-0.5zM1,-4h0.5v0.5h-0.5zM0.5,-3.5h1v0.5h-1zM-0.5,-3h2v1h-2zM0,-2h0.5v3h-0.5z',
    },
    {
      paint: [
        ['cherryTrunk', 0.7],
        ['eggWhite', 0.3],
      ],
      d: 'M-0.5,-5.5h0.5v0.5h-0.5zM-1.5,-5h2.5v0.5h-2.5zM-2,-4.5h3v0.5h-3zM-1,-4h1v0.5h-1z',
    },
    {
      paint: [
        ['cherryTrunk', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-1,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['cherryTrunk', 0.35],
        ['shadow', 0.65],
      ],
      d: 'M-1,-3h0.5v0.5h-0.5z',
    },
  ],
  pixels: 54,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'birdhouseWood', d: 'M-0.5,-1.5h0.5v0.5h-0.5zM-0.5,-1h1v2h-1z' },
    { paint: 'cherryTrunk', d: 'M0,-1.5h0.5v0.5h-0.5z' },
    { paint: 'parasolBlue', d: 'M-1.5,-2.5h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5z' },
    {
      paint: [
        ['parasolBlue', 0.72],
        ['shadow', 0.28],
      ],
      d: 'M1,-4h0.5v0.5h-0.5zM-1.5,-3.5h0.5v1h-0.5zM0.5,-3.5h1v0.5h-1zM-0.5,-3h2v0.5h-2zM-1,-2.5h2.5v0.5h-2.5zM-0.5,-2h1v0.5h-1z',
    },
    { paint: 'tulipRed', d: 'M0,-5.5h0.5v0.5h-0.5zM1,-5h0.5v0.5h-0.5zM1,-4.5h1v0.5h-1z' },
    {
      paint: [
        ['eggWhite', 0.3],
        ['tulipRed', 0.7],
      ],
      d: 'M-0.5,-5.5h0.5v0.5h-0.5zM-1.5,-5h2.5v0.5h-2.5zM-2,-4.5h3v0.5h-3zM-1,-4h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.22],
        ['tulipRed', 0.78],
      ],
      d: 'M-2,-4h1v0.5h-1zM0.5,-4h0.5v0.5h-0.5zM-0.5,-3.5h1v0.5h-1z',
    },
    {
      paint: [
        ['cherryTrunk', 0.35],
        ['shadow', 0.65],
      ],
      d: 'M-1,-3.5h0.5v1h-0.5z',
    },
  ],
  pixels: 54,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'birdhouseWood', d: 'M-1.5,-2.5h1v0.5h-1zM-1,-2h1v0.5h-1zM-0.5,-1.5h0.5v2.5h-0.5z' },
    {
      paint: 'cherryTrunk',
      d: 'M1,-5h0.5v0.5h-0.5zM-2,-4h0.5v0.5h-0.5zM0.5,-4h0.5v0.5h-0.5zM-0.5,-3.5h1v0.5h-1z',
    },
    {
      paint: [
        ['birdhouseWood', 0.72],
        ['shadow', 0.28],
      ],
      d: 'M0,-5.5h0.5v0.5h-0.5zM0.5,-4.5h1v0.5h-1zM-1.5,-4h0.5v1.5h-0.5zM0,-4h0.5v0.5h-0.5zM0.5,-3.5h1v0.5h-1zM-0.5,-3h2v1h-2zM0,-2h0.5v3h-0.5z',
    },
    {
      paint: [
        ['cherryTrunk', 0.7],
        ['eggWhite', 0.3],
      ],
      d: 'M-0.5,-5.5h0.5v0.5h-0.5zM-1.5,-5h2.5v0.5h-2.5zM-2,-4.5h2.5v0.5h-2.5zM-1,-4h1v0.5h-1z',
    },
    {
      paint: [
        ['cherryTrunk', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-1,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['cherryTrunk', 0.35],
        ['shadow', 0.65],
      ],
      d: 'M-1,-3h0.5v0.5h-0.5z',
    },
    { paint: 'winterBirdBrown', d: 'M1.5,-5h0.5v1h-0.5zM1,-4h1v0.5h-1z' },
    { paint: 'tulipYellow', d: 'M2,-4.5h0.5v0.5h-0.5z' },
  ],
  pixels: 57,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
